import type { TestResultsRegisterResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetWidgetTestResultsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';

export const mapTrpcTestResultsToWidgetGraphQL = (
  trpcData: TestResultsRegisterResponseRow[]
): GetWidgetTestResultsQuery => {
  const byControl = new Map<string, TestResultsRegisterResponseRow[]>();
  for (const testResult of trpcData) {
    const parentId = testResult.parent?.Id ?? testResult.ParentControlId;
    if (parentId == null) {
      continue;
    }
    const existing = byControl.get(parentId);
    if (existing) {
      existing.push(testResult);
    } else {
      byControl.set(parentId, [testResult]);
    }
  }

  return {
    control: Array.from(byControl.values()).map((testResults) => ({
      testResults,
    })),
  } as GetWidgetTestResultsQuery;
};
